import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/wangEditor.scss';
// import locale from 'element-ui/lib/locale/lang/cn'
import App from './App'
import router from './router'
import store from './store'
import '@/icons' // icon
import '@/permission' // 权限
import 'babel-polyfill'

Vue.use(ElementUI)

Vue.config.productionTip = false

/*
* 因为服务端的登录问题，推荐使用火狐浏览器，或者谷歌浏览器（但需要做一些额外配置）
*  */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js